import Immutable from 'immutable';

export default Immutable.fromJS({
    setTechStatusReady: (userId, statusActions, firstWorkOrderNumber, currentUserId) => {
      const channels = [userId];
      if(userId !== currentUserId){
          channels.push(currentUserId);
      }

        statusActions.setTechStatusReady({
            techStatusChange: {
              userId: userId,
              techStatusWorkOrder: {
                workOrderNumber: firstWorkOrderNumber,
                arrivalTime: "",
                serviceType:""
              },
              techStatus: "Ready"
            },
            channels: channels
          }, userId);

    },
    setTechStatusNotReady: (userId, statusActions, firstWorkOrderNumber, currentUserId) => {
      const channels = [userId];
      if(userId !== currentUserId){
          channels.push(currentUserId);
      }

        statusActions.setTechStatusNotReady({
            techStatusChange: {
              userId: userId,
              techStatusWorkOrder: {
                workOrderNumber: firstWorkOrderNumber,
                arrivalTime: "",
                serviceType:""
              },
              techStatus: "NotReady"
            },
            channels: channels
          }, userId);

    },
    showArrivalTimeDialog: (userId, statusActions, firstWorkOrderNumber) => {
        statusActions.showArrivalTimeDialog(userId, firstWorkOrderNumber);
    },
    setTechStatusOnJob: (userId, statusActions, firstWorkOrderNumber, currentUserId) => {
      const channels = [userId];
      if(userId !== currentUserId){
          channels.push(currentUserId);
      }
        statusActions.setTechStatusOnJob({
            techStatusChange: {
              userId: userId,
              techStatusWorkOrder: {
                workOrderNumber: firstWorkOrderNumber,
                arrivalTime: ""
              },
              techStatus: "OnJob",
              serviceType:""
            },
            channels: channels
          }, userId);
    },
    setTechStatusUndoOnJob: (userId, statusActions, firstWorkOrderNumber, currentUserId) => {
      const channels = [userId];
      if(userId !== currentUserId){
          channels.push(currentUserId);
      }
        statusActions.setTechStatusUndoOnJob({
            techStatusChange: {
              userId: userId,
              techStatusWorkOrder: {
                workOrderNumber: firstWorkOrderNumber,
                arrivalTime: "",
                serviceType:""
              },
              techStatus: "UndoOnJob"
            },
            channels: channels
          }, userId);
    },
    setTechStatusUndoInRoute: (userId, statusActions, firstWorkOrderNumber, currentUserId) => {
      const channels = [userId];
      if(userId !== currentUserId){
          channels.push(currentUserId);
      }  
      statusActions.setTechStatusUndoInRoute({
            techStatusChange: {
              userId: userId,
              techStatusWorkOrder: {
                workOrderNumber: firstWorkOrderNumber,
                arrivalTime: "",
                serviceType:""
              },
              techStatus: "UndoEnroute"
            },
            channels: channels
          }, userId);
    },
    setTechStatusOnBreak: (userId, statusActions, firstWorkOrderNumber, currentUserId) => {
      const channels = [userId];
      if(userId !== currentUserId){
          channels.push(currentUserId);
      } 
        statusActions.setTechStatusOnBreak({
            techStatusChange: {
              userId: userId,
              techStatusWorkOrder: {
                workOrderNumber: firstWorkOrderNumber,
                arrivalTime: "",
                serviceType:""
              },
              techStatus: "Onbreak"
            },
            channels: channels
          }, userId);
    },
    setTechStatusOffBreak: (userId, statusActions, firstWorkOrderNumber, currentUserId) => {
      const channels = [userId];
      if(userId !== currentUserId){
          channels.push(currentUserId);
      } 
        statusActions.setTechStatusOffBreak({
            techStatusChange: {
              userId: userId,
              techStatusWorkOrder: {
                workOrderNumber: firstWorkOrderNumber,
                arrivalTime: "",
                serviceType:""
              },
              techStatus: "Offbreak"
            },
            channels: channels
          }, userId);
    }
});



// WEBPACK FOOTER //
// ./src/status/statusActionConfig.js